export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute top-0 right-0 w-[60%] h-full opacity-[0.06]">
          <div className="absolute top-10 right-10 w-72 h-72 rounded-full bg-primary-400 blur-3xl"></div>
          <div className="absolute bottom-20 right-40 w-96 h-96 rounded-full bg-accent-400 blur-3xl"></div>
          <div className="absolute top-1/2 right-20 w-64 h-64 rounded-full bg-secondary-400 blur-3xl"></div>
        </div>
      </div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* 左侧文字 */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* 标签 */}
            <div className="inline-flex items-center gap-2 bg-primary-100/80 text-primary-700 text-xs font-medium px-3 py-1.5 rounded-full mb-5">
              <i className="ri-sparkling-line"></i>
              <span>韩漫 · 日漫 · 国漫 一站畅读</span>
            </div>

            {/* H1 */}
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              喵趣漫画
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 mt-1">
                韩漫日漫国漫免费全集 · 下拉式阅读
              </span>
            </h1>

            {/* Slogan */}
            <p className="text-base md:text-lg text-primary-600 font-medium mb-5">
              一口气看完热门漫画大全，阅读从未如此畅快
            </p>

            {/* 简介 */}
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              喵趣漫画网是专为漫画爱好者打造的一站式在线阅读平台。我们精心汇集海量韩漫、日漫与国漫免费全集资源，
              采用创新的下拉式阅读方式，让您无需频繁点击翻页，仅需向下滑动即可沉浸在连续不断的漫画世界中。
              无论是正在热播的韩漫连载、经典永存的日漫名作，还是蓬勃崛起的国漫新秀，
              在这里都能找到属于你的那一部。每日同步更新热门连载，第一时间享受新鲜内容。
            </p>

            {/* 运营数据 */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-900">12,000+</div>
                <div className="text-xs text-foreground-500 mt-0.5">漫画资源</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-900">日更</div>
                <div className="text-xs text-foreground-500 mt-0.5">同步更新</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-900">永久免费</div>
                <div className="text-xs text-foreground-500 mt-0.5">无需充值</div>
              </div>
            </div>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap no-underline text-sm"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-compass-3-line"></i>
                开始探索热门漫画
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 bg-background-100 hover:bg-background-200 text-foreground-800 font-medium px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap no-underline text-sm border border-background-300"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-fire-line"></i>
                查看人气排行
              </a>
            </div>
          </div>

          {/* 右侧主视觉 */}
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20comic%20book%20and%20webtoon%20illustration%20collage%2C%20various%20manga%20characters%20in%20dynamic%20poses%20coming%20out%20of%20a%20smartphone%20screen%2C%20Korean%20Japanese%20Chinese%20comic%20styles%20blended%20harmoniously%2C%20warm%20orange%20and%20coral%20color%20palette%2C%20modern%20digital%20art%2C%20clean%20minimal%20background%2C%20energetic%20and%20lively%20composition%20with%203DX20magical%20sparkles&width=700&height=900&seq=hero-visual&orientation=portrait"
                alt="喵趣漫画 - 韩漫日漫国漫免费全集下拉式在线阅读平台主视觉"
                className="w-full h-auto rounded-lg object-cover"
                width="700"
                height="900"
              />
              {/* 浮动装饰卡片 */}
              <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-lg p-3 border border-background-200/80 hidden lg:block">
                <div className="flex items-center gap-2">
                  <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-check-double-line text-accent-600 text-sm"></i>
                  </span>
                  <div>
                    <div className="text-xs font-semibold text-foreground-800 whitespace-nowrap">下拉式阅读</div>
                    <div className="text-[10px] text-foreground-500 whitespace-nowrap">沉浸流畅体验</div>
                  </div>
                </div>
              </div>
              <div className="absolute -top-4 -right-4 bg-background-50 rounded-lg p-3 border border-background-200/80 hidden lg:block">
                <div className="flex items-center gap-2">
                  <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-fire-line text-primary-600 text-sm"></i>
                  </span>
                  <div>
                    <div className="text-xs font-semibold text-foreground-800 whitespace-nowrap">每日更新</div>
                    <div className="text-[10px] text-foreground-500 whitespace-nowrap">同步连载中</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}